import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchSingleResource } from '../../../staticSiteBackend/resources';
export var createSingleResourceQuery = function createSingleResourceQuery(client, slug) {
  return [["resources/singleResourceQuery", slug], function () {
    return fetchSingleResource({
      client: client,
      url: "/resources/".concat(slug, "/")
    });
  }];
};
export var useSingleResourceQuery = createQueryHook(createSingleResourceQuery, useStaticSiteBackend, {
  staleTime: Infinity
});